import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 600,
    pb: 1,
};

export const descriptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 2,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
};

export const weekStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

/**
 * One weekday: its name on a fixed width so the seven hour ranges line up in a column
 * rather than stepping in and out with the length of the word.
 */
export const dayRowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'baseline',
    gap: 2,
};

export const dayLabelStyles: SxProps<Theme> = {
    fontWeight: 600,
    minWidth: 120,
};

export const dayHoursStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

/** A day nobody works, drawn quieter than one somebody does. */
export const dayOffStyles: SxProps<Theme> = {
    color: 'text.disabled',
    fontStyle: 'italic',
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 2,
};
